export default "__VITE_ASSET__D2v7Idc9__"